import { useContainer } from '@hub-la/fe-container';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useMutation } from 'react-query';
import { QueryKey } from '../../domain/enums/query-keys.js';
import { PutLikeComment } from '../../usecases/put-like-comment.js';

const usePutLikeComment = ({
  onSuccess
} = {}) => {
  const container = useContainer();
  /**@todo: invalidate get comments query or update comments items */
  return useMutation([QueryKey.putComment], input => new PutLikeComment(container.get(HttpClient)).execute(input), {
    retry: false,
    onSuccess
  });
};

export { usePutLikeComment };
